import { reducer } from './data'
import { outdated, languageChanged, steamChanged } from './actions'

export const adsReducer = reducer

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    outdated, // Used by SyncMiddleware
    languageChanged, // Used by LanguageMiddleware
    steamChanged, // Used by SteamMiddleware
}



// WEBPACK FOOTER //
// ./src/features/Ads/exports.js